export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";